import { useMemo } from 'react';
import { useTheme } from '@mui/material';
import { ServiceType } from 'modules/settings/templates/main/interfaces';

export const useAuditScoreColor = (score?: number, serviceType?: ServiceType | undefined) => {
  const theme = useTheme();

  return useMemo(() => {
    if (score === 0) {
      return theme.palette.error.main;
    }

    return ServiceType.BIENSEC === serviceType
      ? score && score < 60
        ? theme.palette.error.main
        : score && score >= 80
          ? theme.palette.success.main
          : theme.palette.warning.main
      : score && score < 80
        ? 'error.main'
        : score && score > 84
          ? 'success.main'
          : 'warning.main';
  }, [score, serviceType, theme.palette.error.main, theme.palette.success.main, theme.palette.warning.main]);
};
